<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"      
      app
      right
      width="550"
      temporary
      hide-overlay
    >
      <v-toolbar
        color="hrissecondary" 
        dark
      >
        <v-toolbar-title class="white--text">
          Advanced Filter
        </v-toolbar-title>
      </v-toolbar>
      <v-container> 
        <v-row no-gutters>
          <v-col cols="12">
            <v-autocomplete
              v-model="hrisRole"
              :items="hrisRoles"              
              label="HRIS"
              placeholder="HRIS Roles"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              small-chips
              multiple
              deletable-chips
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="position"
              :items="positions"              
              label="Position"
              placeholder="Positions"
              item-text="label"
              item-value="id"
              hide-no-data
              hide-selected
              small-chips
              multiple
              deletable-chips
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="department"
              :items="departments"              
              label="Department"
              placeholder="Departments"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              small-chips
              multiple
              deletable-chips
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete 
              v-model="company"
              :items="companies"
              label="Payroll Company"
              placeholder="Payroll Companies"
              small-chips
              multiple
              deletable-chips
              hide-no-data
              hide-selected
              item-text="name"
              item-value="id"
              clearable
            />
          </v-col>

          <v-col cols="12">
            <v-autocomplete 
              v-model="costCenter"
              :items="filteredCostCenters"
              label="Cost Center"
              placeholder="Cost Centers"
              small-chips
              multiple
              deletable-chips
              hide-no-data
              hide-selected
              item-text="label"
              item-value="id"
              clearable
            />
          </v-col>

          <v-col cols="12">
            <v-menu
              v-model="dateRangeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateRangeDisplay"
                  label="Joined Date"  
                  readonly
                  class="label-position"
                  prepend-icon="mdi-calendar"
                  placeholder="Select the date range for joined date"
                  clearable
                  v-on="on"
                  @click:clear="dateRange = []"
                />
              </template>
              <v-date-picker
                v-model="dateRange"
                :max="today"
                range
                no-title
                :allowed-dates="allowedDates"
              />
            </v-menu>
          </v-col>

          <v-row 
            no-gutters 
            align="center" 
            class="custom-slider-wrapper mt-2"
          >
            <v-col cols="12">
              <span class="caption">Service Length:</span>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model.number="value[0]"
                type="number"
                :min="0"
                :max="value[1]"
                outlined
                dense
                hide-details
                label="Min Year"
              />
            </v-col>

            <v-col 
              cols="8" 
              class="px-8"
            >
              <v-range-slider
                v-model="value"
                step="1"
                thumb-label="always"
                :thumb-size="30"
                :min="0"
                :max="50"
                strict
                color="hrissecondary"
                track-color="light-grey"
                track-size="5"
                class="mt-4"
              >
                <template v-slot:thumb-label="{ value }">
                  <span>{{ value }}y</span>
                </template>
              </v-range-slider>
            </v-col>

            <v-col cols="2">
              <v-text-field
                v-model.number="value[1]"
                type="number"
                :min="value[0]"
                :max="50"
                outlined
                dense
                hide-details
                label="Max Year"
              />
            </v-col>
          </v-row>

          <v-col
            cols="12"
            class="text-center"
          >
            <v-btn
              block
              color="hrissecondary"
              class="white--text"
              @click="loadUserOverview"
            >
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>

    <v-container
      v-show="!isProfile"    
      class="hidden-sm-and-down"
      fluid
    >
      <v-row 
        no-gutters
      >
        <v-col cols="12">
          <v-card>
            <v-toolbar
              flat
              color="white"
            >
              <v-text-field
                ref="searchInput"
                v-model="searchInput"
                autofocus
                append-icon="search"
                placeholder="Search by name, username, employee ID, IC or passport number"
                single-line
                hide-details
                clearable
              />
              <v-spacer />
              <v-tooltip
                v-if="isFiltering"
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn   
                    text
                    icon           
                    color="primary"
                    v-on="on"
                    @click="clearFilter"
                  >
                    <v-icon 
                      color="error"                      
                      medium
                    >
                      mdi-close
                    </v-icon>
                  </v-btn> 
                </template>
                <span>Clear filter</span>
              </v-tooltip>
              <v-tooltip
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn   
                    text
                    icon           
                    color="primary"
                    v-on="on"
                    @click.stop="drawer = true"
                  >
                    <v-icon 
                      v-if="isFiltering" 
                      medium
                    >
                      filter_list_alt
                    </v-icon>
                    <v-icon 
                      v-else
                      medium
                    >
                      filter_list
                    </v-icon>
                  </v-btn> 
                </template>
                <span>Advanced filter</span>
              </v-tooltip>
            
              <v-tooltip
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-avatar 
                    class="cursor-pointer"
                    v-on="on"
                    @click="loadUserOverview"                
                  >
                    <v-icon medium>
                      mdi-refresh
                    </v-icon>
                  </v-avatar>
                </template>
                <span>Reload</span>
              </v-tooltip>

              <user-stepper-create
                ref="stepper"
                @openProfile="openProfile"
                @reloadEmployeeList="loadUserOverview"
              />
            </v-toolbar>

            <v-data-table
              hide-default-footer
              :items="employees"
              :headers="filteredHeaders"
              dense
              class="mt-2"
            > 
              <template v-slot:item.person="{ item }">
                <v-row 
                  class="ml-0" 
                  :style="{ 
                    cursor: item.status === 'draft' && $hasPermissionTo(['view draft employees']) && !$hasPermissionTo(['update draft employees']) ? 'not-allowed' : 'pointer'
                  }"
                >
                  <v-avatar
                    color="teal"
                    size="40"
                    @click="handleRowOnClick(item)"
                  >
                    <img
                      :src="item.thumbnail_url"
                      alt="avatar"
                    >
                  </v-avatar>
    
                  <span
                    class="font-weight-bold ml-3 font-calibri"
                    @click="handleRowOnClick(item)"
                  >
                    <div
                      :class="[{ 'pt-2': !$hasPermissionTo(['view draft employees']) || item.status === 'complete' }]"
                      :style="{'max-width': '236px'}"
                    >{{ (item.person || {}).name }}</div>
                    <div 
                      v-if="item.status === 'draft' && $hasPermissionTo(['view draft employees'])"
                      class="red--text"
                    >(Incomplete profile)</div>
                  </span>
                </v-row>
              </template>

              <template v-slot:item.employee_number="{ item }">
                <span class="font-weight-bold ml-3 font-calibri">
                  {{ getEmployeeId(item.employee_number) }}
                </span>
              </template>

              <template v-slot:item.ic_number="{ item }">
                <div>
                  <span
                    class="font-weight-bold font-calibri"
                  >
                    {{ ((item.person || {}).identity_card || {}).ic_number ? ((item.person || {}).identity_card || {}).ic_number : ((item.person || {}).identity_card || {}).passport_number }}
                  </span>
                </div>
              </template>

              <template v-slot:item.joined_date="{ item }">
                <div>
                  <span
                    class="font-weight-bold font-calibri"
                  >
                    <div>{{ $moment(item.joined_date).format('DD MMM YYYY') }}</div>
                    <div class="caption cyan--text">{{ 'Service: ' + yearOfServiceDisplay(item) + ' years' }}</div>
                  </span>
                </div>
              </template>

              <template v-slot:item.position="{ item }">
                <div>
                  <span class="font-weight-bold ml-3 font-calibri">
                    {{ (((item.current_position ||{}).position||{}).name) }}
                  </span>
                </div>
              </template>

              <template v-slot:item.username="{ item }">
                <div>
                  <span class="font-weight-bold ml-3 font-calibri">
                    {{ (((item.person ||{}).user||{}).username) }}
                  </span>
                </div>
              </template>

              <template v-slot:item.status="{ item }">
                <div v-if="item.is_active_employment">
                  <v-fade-transition>
                    <v-avatar
                      :style="{
                        animationDuration: `0.9s`
                      }"
                      :color="getStatusColor(item)"
                      class="mb-1 v-avatar--metronome"
                      size="12"
                    />
                  </v-fade-transition>
                  <span
                    class="ml-1 green--text font-calibri"
                  > Active </span>
                </div>

                <div v-else>
                  <v-fade-transition>
                    <v-avatar
                      :style="{
                        animationDuration: `5s`
                      }"
                      :color="getStatusColor(item)"
                      class="mb-1 v-avatar--metronome"
                      size="12"
                    />
                  </v-fade-transition>
                  <span
                    v-if="isResigned(item)"
                    class="ml-1 grey--text font-calibri"
                  > 
                    {{ item.current_separation ? item.current_separation.type.name : 'Resigned' }} 
                  </span>
                  <span
                    v-else-if="isPending(item)"
                    class="ml-1 warning--text font-calibri"
                  > Pending </span>
                  <span
                    v-else
                    class="ml-1 info--text font-calibri"
                  > On Leave </span>
                </div>
              </template>
                
              <template v-slot:item.action="{ item }">
                <div>
                  <employee-menu-action
                    v-if="$hasPermissionTo(['change employee password'])"
                    :user="(item.person || {}).user"
                    :system-setting-value="systemSettingValue"
                    @updated="updatePage"
                  />
                </div>
              </template>
            </v-data-table>
            <v-divider class="ml-0 mr-0" />
            <v-container class="text-right">
              <v-btn
                icon
                color="primary"
                :disabled="currentPage === 1"
                @click="previousPage"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <span class="pagination">{{ from }}-{{ to }} of {{ total }}</span>
              <v-btn
                icon
                color="primary"
                :disabled="currentPage === lastPage"
                @click="nextPage"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container> 

    <v-fade-transition>
      <employee-profile-view 
        v-show="isProfile"
        :employee-uid="employee.employee_uid"
        :person-uid="person.person_uid"
        :user-uid="user.user_uid"
      >
        <template v-slot:navigation>
          <v-breadcrumbs 
            :items="navItems" 
            divider="/"
            class="py-0"
          >
            <template v-slot:item="props">
              <a  
                :class="[props.item.disabled && 'disabled']"
                @click="updatePage"
              >{{ props.item.text }}</a>
            </template>
          </v-breadcrumbs>
        </template>
      </employee-profile-view>
    </v-fade-transition> 
                  
    <user-stepper-edit
      ref="editStepper"
      @openProfile="openProfile"
      @reloadEmployeeList="loadUserOverview"
    />
  
    <v-overlay :value="tableLoading">
      <div class="fingerprint-spinner">
        <div class="spinner-ring" />
        <div class="spinner-ring" />
        <div class="spinner-ring" />
        <div class="spinner-ring" />
        <div class="spinner-ring" />
        <div class="spinner-ring" />
        <div class="spinner-ring" />
        <div class="spinner-ring" />
        <div class="spinner-ring" />
      </div>
    </v-overlay>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfileView: () => import('@/components/hris/employee/ProfileView'),
      EmployeeMenuAction: () => import('@/components/hris/user/EmployeeMenuAction'),
      UserStepperCreate: () => import('@/components/user/StepperCreate'),
      UserStepperEdit: () => import('@/components/user/StepperEdit'),
    },

    metaInfo () {
      return {
        title: 'Employee Overview',
      }
    },
    data () {
      return {      
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'person',
            sortable: false,
          },
          {
            text: 'Employee ID',
            align: 'left',
            value: 'employee_number',
            sortable: false,
          },
          {
            text: 'IC/Passport No.',
            align: 'center',
            value: 'ic_number',
            sortable: false,
          },
          {
            text: 'Joined Date',
            align: 'center',
            value: 'joined_date',
            sortable: false,
          },
          {
            text: 'Position',
            align: 'left',
            value: 'position',
            sortable: false,
          },
          {
            text: 'Username',
            align: 'left',
            value: 'username',
            sortable: false,
          },
          {
            text: 'Status',
            align: 'left',
            value: 'status',
            sortable: false,
          },
        ],
        searchInput: '',
        employees: [],
        employee: {},
        person: {},
        user: {},
        skeleton: true,
        tableLoading: false,
        isProfile: false,
        navItems: [
          {
            text: 'Overview',
            disabled: false,
            to: { path: '/employees-hris' }, 
            exact: true,
          },
          {
            text: 'Profile',
            disabled: true,
          },
        ],
        total: 0,
        from: 0,
        to: 0,
        lastPage: 0, 
        currentPage: 1,
        employeeNumberStarter: [],
        drawer: null,
        hrisRole: [],
        position: [],
        department: [],
        company: [],
        costCenter: [],
        hrisRoles: [],
        positions: [],
        departments: [],
        companies: [],
        costCenters: [],
        filteredCostCenters: [],
        systemSettingValue: 0,
        dateRangeMenu: false,
        dateRange: [],
        today: new Date().toISOString().slice(0, 10), 
        value: [0, 50],
      }
    },
    computed: {
      filteredHeaders () {
        return this.canEditPassword() ? [...this.headers, {
          text: '',
          align: 'center',
          value: 'action',
          sortable: false,
        },
        ] : this.headers
      },
      isFiltering () {
        return !_.isEmpty(this.hrisRole) ||
          !_.isEmpty(this.position) ||
          !_.isEmpty(this.department) ||
          !_.isEmpty(this.company) ||
          !_.isEmpty(this.costCenter) ||
          !_.isEmpty(this.dateRange) ||
          this.value[0] > 0 || 
          this.value[1] < 50
      },
      dateRangeDisplay () {
        if (Array.isArray(this.dateRange) && this.dateRange.length === 2) {
          const [start, end] = this.dateRange
          const startFormatted = this.$moment(start).format('DD MMM YYYY')
          const endFormatted = this.$moment(end).format('DD MMM YYYY')
          return `${startFormatted} - ${endFormatted}`
        } else {
          return ''
        }
      },
    },
    watch: {
      company: {
        immediate: true,
        deep: true,
        handler (newVal) {
          if (!newVal || newVal.length <= 0) {
            this.filteredCostCenters = this.costCenters
          } else {
            this.filteredCostCenters = this.costCenters.filter(cc =>
              newVal.includes(cc.selected_company_uid)
            )
          }
        },
      },
      searchInput (val) {
        clearTimeout(this._searchTimerId)
        this._searchTimerId = setTimeout(() => {
          this.tableLoading = true
          this.loadSystemSettings()
          this.loadUserOverview()
        }, 500) /* 500ms throttle */
      },
    },
    created () {
      this.$store.state.isMyProfile = false

      Promise.all([
        this.$api.roles('hris').list(),
        this.$api.positions().list(),
        this.$api.hrisDepartments().list(['name'], false, true),
        this.$api.hrisCompanies().list(),
        this.$api.costCenters().listAll(),
      ])
        .then(([hrisRoles, positions, departments, companies, costCenters]) => {
          this.hrisRoles = hrisRoles.data

          this.positions = positions.data.map(pos => ({
            id: pos.id,
            label: `${pos.name} (${pos.job_grade.job_group.name})`,
          }))

          this.departments = departments.data
          this.companies = companies.data
          
          this.costCenters = costCenters.data.map(cc => ({
            id: cc.id,
            name: cc.name,
            selected_company_uid: cc.selected_company_uid,
            label: `${cc.name} (${cc.selected_company.name})`,
          }))

          this.filteredCostCenters = this.costCenters

          this.loading = false
        })
    },
    mounted () {
      this.loadSystemSettings()
      this.loadUserOverview()
    },
    methods: {
      getEmployeeId (employeeNumber) {
        // preset 10 digits of 0
        employeeNumber = '0000000000' + employeeNumber
        // cut the digits based on EMPLOYEE_NUMBER_LENGTH setting
        return (this.employeeNumberStarter || {}).value + employeeNumber.substring(employeeNumber.length - this.employeeNumberLengthSetting.value, employeeNumber.length)
      },
      loadSystemSettings () {
        this.$api.systemSettings().list()
          .then((res) => {
            this.systemSettingValue = res.data.find(setting => 
              setting.key === 'KATIMAS_WORKSPACE_INTEGRATION'
            ).value
            this.employeeNumberLengthSetting = res.data.find(setting => 
              setting.key === 'EMPLOYEE_NUMBER_LENGTH'
            )
            this.employeeNumberStarter = res.data.find(setting => 
              setting.key === 'EMPLOYEE_NUMBER_STARTER'
            )
          })
          .catch(() => {})
      },
      loadUserOverview (userUid = null) {
        this.tableLoading = true

        this.$api.employeeOverviews().list('', this.prepareFormData())
          .then(res => {
            this.setPaginationDetails(res.data)
            this.employees = res.data.data

            this.tableLoading = false
          })
      },
      updatePage () {
        let currentEmployeeUid = this.employee.employee_uid

        this.$api.employeeOverviews().list('?page=' + this.currentPage, this.prepareFormData())
          .then(response => {
            this.$set(this.employees, this.employees.findIndex(employee => employee.employee_uid === currentEmployeeUid), response.data)
          
            this.$refs.searchInput.focus() 
            this.employees = response.data.data
          })

        this.isProfile = false
      },     
      handleRowOnClick (item) {
        if (this.isVessel(item)) {
          this.openProfile(item)
        }

        this.validateEmployeeStatus(item)
      },
      validateEmployeeStatus (item) {
        if (item.status === 'complete') {
          this.isLoading = true

          this.$api.userPermissions().show(((item.person || {}).user || {}).user_uid, 'view employees')
            .then(response => {
              this.openProfile(item)          
            })
            .catch(err => {
              if (err.response.status === 404) {
                this.validateStepperStatus(item)
              }
            })
            .then(() => {
              this.isLoading = false
            })
        } else {
          if (this.$hasPermissionTo(['update draft employees'])) {
            this.$refs.editStepper.toggleDialog(item)
          }
        }
      }, 
      validateStepperStatus (item) {
        this.isLoading = true

        this.$api.reportTo().show(item.employee_uid)
          .then(reportToResponse => {
            let reportTo = reportToResponse.data

            if (
              (!this.hasPerson(item) || !this.hasReportTo(reportTo)) && 
              this.$hasPermissionTo(['create employees section'])
            ) {
              this.$refs.stepper.toggleDialog(item, reportTo.person)
            } else {                 
              this.openProfile(item)
            }
          })
          .catch(() => {
            if (this.$hasPermissionTo(['create employees section'])) {
              this.$refs.stepper.toggleDialog(item, undefined)
            }
          })
      },
      getStatusColor (employee) {
        if (this.isResigned(employee)) {
          return 'grey'
        } else if (this.isPending(employee)) {
          return 'warning'
        } else if (this.isOnLeave(employee)) {
          return 'info'
        } else {
          return 'green'
        }
      },
      isResigned (employee) {
        return employee.end_date !== null && employee.end_date <= this.$moment().format('YYYY-MM-DD')
      },
      isPending (employee) {
        return employee.joined_date > this.$moment().format('YYYY-MM-DD')
      },
      isOnLeave (employee) {
        return employee.is_active === 0
      },
      canEditPassword () {
        return this.$hasPermissionTo(['change employee password'])
      },
      isVessel (item) {
        return ((item.person || {}).user || {}).vessel !== null && ((item.person || {}).user || {}).vessel !== undefined
      },
      openProfile (employee) {
        this.employee = employee
        this.person = employee.person
        this.user = ((employee.person || {}).user || {}) || ''

        this.isProfile = true
      },
      hasPerson (item) {
        return item.person !== null
      },
      hasReportTo (reportTo) {
        return reportTo.person !== undefined
      },
      setPaginationDetails (page) {
        this.total = page.total
        this.from = page.from
        this.to = page.to
        this.lastPage = page.last_page
        this.currentPage = page.current_page
      },
      nextPage () {
        this.tableLoading = true

        this.$api.employeeOverviews().list('?page=' + (this.currentPage + 1), this.prepareFormData())
          .then(res => {
            this.employees = res.data.data
            this.setPaginationDetails(res.data)
    
            this.tableLoading = false
          })
      },
      previousPage () {
        this.tableLoading = true

        this.$api.employeeOverviews().list('?page=' + (this.currentPage - 1), this.prepareFormData())
          .then(res => {
            this.employees = res.data.data
            this.setPaginationDetails(res.data)
    
            this.tableLoading = false
          })
      },
      prepareFormData () {
        return {
          searchInput: this.searchInput,
          hrisRoles: this.hrisRole,
          positions: this.position,
          departments: this.department,
          companies: this.company,
          costCenters: this.costCenter,
          dateRange: this.getAllDatesInRange(),
          serviceLength: this.value,
        }
      },
      yearOfServiceDisplay (employee) {
        var noOfDaysInCurrentYear = this.$moment().endOf('year').diff(this.$moment().startOf('year'), 'days') + 1 // includes day 1
        if (employee.end_date) {
          return ((this.$moment(employee.end_date).diff(this.$moment(employee.joined_date), 'days') + 1) / noOfDaysInCurrentYear).toFixed(2)
        }
        return ((this.$moment().diff(this.$moment(employee.joined_date), 'days') + 1) / noOfDaysInCurrentYear).toFixed(2)
      },
      getAllDatesInRange () {
        const [start, end] = this.dateRange
        if (!start || !end) return []
        const startDate = this.$moment(start)
        const endDate = this.$moment(end)
        const dateList = []
        while (startDate.isSameOrBefore(endDate)) {
          dateList.push(startDate.format('YYYY-MM-DD'))
          startDate.add(1, 'day')
        }
        return dateList
      },
      clearFilter () {
        this.hrisRole = []
        this.position = []
        this.department = []
        this.company = []
        this.costCenter = []
        this.dateRange = []
        this.value = [0, 50]
        this.loadUserOverview()
      },
      allowedDates (date) {
        // if only the first date (start) is selected
        if (this.dateRange.length === 1) {
          const start = this.dateRange[0]
          // disable any date *before* the start
          return date >= start
        }
        // otherwise allow all dates (default)
        return true
      },
    },
  }
</script>

<style scoped>
.font-calibri
{
  font-family: Calibri;
}

.pagination{
  font-size:12px;
  color:#5F6368
}

.white-background{
  background: white
}

.v-avatar--metronome {
  animation-name: metronome-example;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

.disabled {
  color: grey;
  pointer-events: none;
}

::v-deep .v-toolbar__content{
  margin-left:0px !important;
}

@keyframes metronome-example {
  from {
    transform: scale(.5);
  }

  to {
    transform: scale(1);
  }
}

.cursor-pointer{
  cursor: pointer;
} 

.fingerprint-spinner, .fingerprint-spinner * {
  box-sizing: border-box;
}

.fingerprint-spinner {
  height: 648px;
  width: 64px;
  padding: 4px;
  overflow: hidden;
  position: relative;
}

.fingerprint-spinner .spinner-ring {
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: rgb(9, 226, 255);
  animation: fingerprint-spinner-animation 1500ms cubic-bezier(0.680, -0.750, 0.265, 1.750) infinite forwards;
  margin: auto;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}

.fingerprint-spinner .spinner-ring:nth-child(1) {
  height: calc(60px / 9 + 0 * 60px / 9);
  width: calc(60px / 9 + 0 * 60px / 9);
  animation-delay: calc(50ms * 1);
}

.fingerprint-spinner .spinner-ring:nth-child(2) {
  height: calc(60px / 9 + 1 * 60px / 9);
  width: calc(60px / 9 + 1 * 60px / 9);
  animation-delay: calc(50ms * 2);
}

.fingerprint-spinner .spinner-ring:nth-child(3) {
  height: calc(60px / 9 + 2 * 60px / 9);
  width: calc(60px / 9 + 2 * 60px / 9);
  animation-delay: calc(50ms * 3);
}

.fingerprint-spinner .spinner-ring:nth-child(4) {
  height: calc(60px / 9 + 3 * 60px / 9);
  width: calc(60px / 9 + 3 * 60px / 9);
  animation-delay: calc(50ms * 4);
}

.fingerprint-spinner .spinner-ring:nth-child(5) {
  height: calc(60px / 9 + 4 * 60px / 9);
  width: calc(60px / 9 + 4 * 60px / 9);
  animation-delay: calc(50ms * 5);
}

.fingerprint-spinner .spinner-ring:nth-child(6) {
  height: calc(60px / 9 + 5 * 60px / 9);
  width: calc(60px / 9 + 5 * 60px / 9);
  animation-delay: calc(50ms * 6);
}

.fingerprint-spinner .spinner-ring:nth-child(7) {
  height: calc(60px / 9 + 6 * 60px / 9);
  width: calc(60px / 9 + 6 * 60px / 9);
  animation-delay: calc(50ms * 7);
}

.fingerprint-spinner .spinner-ring:nth-child(8) {
  height: calc(60px / 9 + 7 * 60px / 9);
  width: calc(60px / 9 + 7 * 60px / 9);
  animation-delay: calc(50ms * 8);
}

.fingerprint-spinner .spinner-ring:nth-child(9) {
  height: calc(60px / 9 + 8 * 60px / 9);
  width: calc(60px / 9 + 8 * 60px / 9);
  animation-delay: calc(50ms * 9);
}

@keyframes fingerprint-spinner-animation {
  100% {
    transform: rotate( 360deg );
  }
}
/* Ensure the wrapper container sits exactly over the middle of the slider handle */
.custom-slider-wrapper ::v-deep .v-slider__thumb-label-container {
  display: flex !important;
  justify-content: center !important;
  width: 0 !important; /* Collapses container width to keep it centered at 0 point */
}

/* Center the square bubble perfectly */
.custom-slider-wrapper ::v-deep .v-slider__thumb-label {
  position: absolute !important;
  left: 50% !important;
  /* Clears the native rotation and forces true center horizontal alignment */
  transform: translateX(-50%) !important; 
  border-radius: 6px !important;
  top: -44px !important; /* Adjust height position over the bar */
}

/* Keep the text inside standing upright and single-lined */
.custom-slider-wrapper ::v-deep .v-slider__thumb-label > * {
  transform: none !important;
  white-space: nowrap;
}

/* Position the triangle tip exactly in the center under the bubble */
/* Position a rotated square beneath the bubble that inherits the exact background color */
.custom-slider-wrapper ::v-deep .v-slider__thumb-label::after {
  content: '';
  position: absolute;
  bottom: -4px; /* Controls how far down the tip pokes out */
  left: 50%;
  
  /* Centering + 45-degree turn to make it a diamond/triangle point */
  transform: translateX(-50%) rotate(45deg) !important; 
  
  width: 8px;
  height: 8px;
  background-color: inherit; /* 💡 Dynamic match for hrissecondary color */
  display: block;
  z-index: -1; /* Tucks it neatly behind the main box text area */
}
</style>
